import getDifferenceOnDays from 'utils/date/getDifferenceOnDays'
import { dateToString, alterDate, stringToDate } from '@hc-frontend/utils'

interface periodRangeParameters {
  period: number
  sDate: Date
  extendedPeriod?: number
  endDate?: any
  policies: number
}

function getPeriodRange({
  period,
  extendedDuration = period,
  sDate,
  endDate = null,
  policies
}: periodRangeParameters) {
  endDate = endDate
    ? stringToDate(endDate)
    : alterDate({
        date: sDate,
        days:
          extendedDuration === period
            ? period * policies - 1
            : period + extendedDuration - 1
      })

  const startParts = sDate.toDateString().split(' ')
  const endParts = endDate.toDateString().split(' ')
  const days = getDifferenceOnDays(sDate, endDate)

  return {
    slash: {
      start: dateToString(sDate),
      end: dateToString(endDate)
    },
    monthName: {
      start: `${startParts[1]} ${+startParts[2]}, ${startParts[3]}`,
      end: `${endParts[1]} ${+endParts[2]}, ${endParts[3]}`
    },
    days
  }
}

export default getPeriodRange
